import { Media } from '@jd/platform-config';
import { DeepNullToUndefined } from '@jd/client/utils/unnulable';
import { blurhashToBase64 } from 'blurhash-base64';
import { RichTextContent } from '../../components/RichText';

type InputType = string | DeepNullToUndefined<Media> | undefined | null;

export type TBImgType = {
  url: string;
  blurDataUrl?: string;
  altText: string;
  meta: {
    height?: number;
    width?: number;
    aspectRatio: number;
  };
  folderId?: string;
  folder?: {
    title?: RichTextContent;
    subtitle?: RichTextContent;
    description?: RichTextContent;
  };
};

const resolveFolder = (
  input: string | Record<string, any> | undefined,
): string | undefined => {
  return typeof input === 'string' ? input : input?.id;
};

const imgMapper = (input: InputType): TBImgType | undefined => {
  if (!input || typeof input === 'string') return undefined;
  return {
    url: input.url || '#',
    altText: input.alt,
    blurDataUrl: input.blurhash ? blurhashToBase64(input.blurhash) : undefined,
    meta: {
      height: input.height,
      width: input.width,
      aspectRatio: (input.width || 0) / (input.height || 1) || 1,
    },
    folderId: resolveFolder(input.folder),
    folder:
      typeof input.folder === 'object'
        ? {
            title: input.folder.title,
            subtitle: input.folder.subtitle,
            description: input.folder.description,
          }
        : undefined,
  };
};

export default imgMapper;
